import { WHITE, NEUTRAL_1600 } from 'visitor-ui-component-library/constants/WidgetColors';

/**
 * Design tokens for Spotlight form-factor components.
 *
 * Source of truth: https://git.hubteam.com/pages/fosullivan/AI-SDR-Storybook/
 */
export const spotlightTheme = {
  /**
   * 4-based spacing scale.
   * @see https://git.hubteam.com/pages/fosullivan/AI-SDR-Storybook/?path=/story/foundations-design-tokens--spacing
   * @example margin-bottom: ${spotlightTheme.spacing.sm}
   */
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '20px',
    xxl: '24px',
    xxxl: '32px'
  },
  /**
   * Border radius scale.
   * @see https://git.hubteam.com/pages/fosullivan/AI-SDR-Storybook/?path=/story/foundations-design-tokens--radii
   */
  borderRadius: {
    /** icon buttons, dropdowns */
    sm: '8px',
    /** color swatches, booking card */
    md: '10px',
    /** widget shell, booking card body */
    lg: '12px',
    /** widget shell corners */
    xl: '16px',
    /** confirm button, time slots, duration pills, user bubble */
    pill: '9999px'
  },
  /**
   * Typography scale.
   * @see https://git.hubteam.com/pages/fosullivan/AI-SDR-Storybook/?path=/story/foundations-design-tokens--typography
   */
  typography: {
    fontSize: {
      /** widget subtitle, uppercase labels */
      xs: '11px',
      /** reasoning / meta */
      sm: '11.5px',
      /** slots / calendar, calendar days */
      md: '12px',
      /** confirm button, status title */
      lg: '13px',
      /** ask suggestions */
      lgHalf: '13.5px',
      /** widget title, message body, user bubble */
      xl: '14px'
    },
    fontWeight: {
      regular: 400,
      /** calendar days */
      semibold: 600,
      /** uppercase labels */
      bold: 700
    },
    lineHeight: {
      /** body text */
      md: '18px',
      /** larger body text */
      lg: '20px'
    }
  },
  /**
   * Brand and semantic colors.
   * @see https://git.hubteam.com/pages/fosullivan/AI-SDR-Storybook/?path=/story/foundations-design-tokens--colours
   */
  color: {
    /** card and panel surfaces — shared from WidgetColors.WHITE */
    surface: WHITE,
    // Brand
    /** #FF4800 — primary brand orange, unread indicators */
    orange: '#FF4800',
    /** primary text — shared from WidgetColors.NEUTRAL_1600 */
    ink: NEUTRAL_1600,
    /** #6b7280 — secondary / muted text */
    muted: '#6b7280',
    // Surface
    /** #fafafa — default background */
    bg: '#fafafa',
    /** #e5e7eb — borders, dividers */
    border: '#e5e7eb',
    /** #F0F0F0 — user message bubble background */
    userBubble: '#F0F0F0',
    /** #8A8A8A — selected stroke */
    selectedStroke: '#8A8A8A',
    // Semantic
    success: '#16a34a',
    successBg: '#dcfce7',
    error: '#dc2626',
    errorBg: '#fee2e2',
    // Widget chrome
    /** rgba(0,0,0,0.85) — primary message text */
    messageText: 'rgba(0,0,0,0.85)',
    /** #767676 — muted chrome elements */
    mutedChrome: '#767676'
  },
  /**
   * Elevation shadows.
   */
  shadow: {
    /** Two-layer widget shell shadow — large diffused lift + thin crisp definition */
    card: '0 4px 24px #0000001a, 0 1px 6px #0000000f',
    /** Dropdown / popover */
    popover: '0 2px 8px #00000014'
  },
  /**
   * Z-index layers.
   */
  zIndex: {
    /** 9999 — overlays, popovers, floating cards */
    overlay: 9999
  }
};